export const site = {
  name: "Fabulous J",
  email: "fabulousjay01@gmail.com",
  github: "https://github.com/Fabulousjay",
  linkedin: "https://www.linkedin.com/in/emmanuel-ayomiposi/",
};
export const navigation = ["Work", "About", "Experience", "Contact"] as const;
